import fromAnyToTrimmed from 'utils/converters/any/fromAnyToTrimmed.util';
import fromAnyToString from 'utils/converters/fromAnyToString';
import withOptions from 'utils/functions/withOptions.util';

const determineDisplayNumberOf = withOptions(({ defaultValue, isHoursSelected, days, hours }) => {
  const value = fromAnyToTrimmed(isHoursSelected ? hours : days);

  return fromAnyToString(value || defaultValue || '');
});

export default determineDisplayNumberOf;
